<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="section"><strong class="bold">THE LYING LIFE <br/>OF ADULTS</strong></h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// lying-life-3.vue?4f67bcd7